import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperAmenitiesFacilitiesComponent: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    containerHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    cardWapper: {
      display: "flex",
      flexDirection: "row",
      gap: "24px",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
    },
  };
});
